/**
 * Ленивая загрузка HUD ведения (follow) — тот же паттерн, что IsoLazy/ArLazy:
 * этажный замок и остальной код ведения нужны не каждому посетителю,
 * стартовый бандл его не платит (check:bundle).
 *
 * `warmFollowHud()` (план 24.09 п.1) тянет тот же чанк заранее, в простое
 * после загрузки карты — «Поехали» без сети должен работать с первого
 * открытия, а не только со второго визита (см. web/src/sw/warm-assets.ts).
 * Модульный кеш (`cached`) общий с FollowLazy — повторного импорта нет.
 */
import type { ComponentType } from 'preact'
import { useEffect, useState } from 'preact/hooks'
import { importChunk } from '../lazy-retry'

let cached: ComponentType | null = null
let warming: Promise<void> | null = null

/** Заранее прогреть чанк ведения (main.tsx, idle после карты). */
export function warmFollowHud(): Promise<void> {
  if (cached) return Promise.resolve()
  if (warming) return warming
  warming = importChunk(() => import('./follow-hud'))
    .then((m) => {
      cached = m.FollowHud
    })
    .catch(() => {
      // Сеть пропала до прогрева — следующий вызов (событие online, main.tsx)
      // попробует снова, а не вернёт этот провал навсегда.
      warming = null
    })
  return warming
}

export function FollowLazy() {
  // Ленивый инициализатор обязателен (см. IsoLazy): иначе Preact вызвал бы
  // компонент как функцию-инициализатор состояния.
  const [View, setView] = useState<ComponentType | null>(() => cached)

  useEffect(() => {
    if (View) return
    let alive = true
    void importChunk(() => import('./follow-hud'))
      .then((m) => {
        cached = m.FollowHud
        if (alive) setView(() => m.FollowHud)
      })
      .catch(() => undefined)
    return () => {
      alive = false
    }
  }, [View])

  if (!View) return null
  return <View />
}
